import React from 'react';
import { Tooltip, Modal, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import customerJourneyNodeService from '../../../services/customerJourneyNodeService';

const JourneyNodeTimeline = ({ nodes = [] }) => {
  const navigate = useNavigate();
  
  if (!nodes || nodes.length === 0) {
    return <span style={{ color: '#999', fontSize: '12px' }}>暂无阶段</span>;
  }

  // 处理阶段点击
  const handleNodeClick = async (node, index) => {
    try {
      const response = await customerJourneyNodeService.getNodeSopInfo(node.id);
      
      if (response.data.success && response.data.data) {
        const sopInfo = response.data.data;
        
        if (sopInfo.hasSop) {
          // 有关联的SOP，询问是否跳转
          Modal.confirm({
            title: '发现关联的智能体',
            content: `阶段 "${node.nodeName}" 已关联智能体 "${sopInfo.sopTemplateName}"，是否跳转到智能体页面？`,
            okText: '跳转',
            cancelText: '取消',
            onOk: () => {
              // 跳转到SOP编辑页面
              navigate(`/sop-template/edit/${sopInfo.sopTemplateId}`);
            }
          });
        } else {
          // 没有关联的SOP，询问是否创建
          Modal.confirm({
            title: '创建智能体',
            content: `阶段 "${node.nodeName}" 还没有关联的智能体，是否创建新的智能体？`,
            okText: '创建',
            cancelText: '取消',
            onOk: () => {
              // 跳转到SOP创建页面，并传递标签信息
              const createUrl = sopInfo.tagId 
                ? `/sop-template/create?tagId=${sopInfo.tagId}&tagName=${encodeURIComponent(sopInfo.tagName || node.nodeName)}`
                : `/sop-template/create?nodeName=${encodeURIComponent(node.nodeName)}`;
              navigate(createUrl);
            }
          });
        }
      } else {
        message.error('获取阶段信息失败');
      }
    } catch (error) {
      console.error('处理阶段点击失败:', error);
      message.error('操作失败，请稍后重试');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center',
      position: 'relative',
      padding: '20px 0',
      minHeight: '60px',
      background: 'linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%)',
      borderRadius: '8px',
      border: '1px solid #e6f7ff'
    }}>
      {/* 连接线 - 从第一个阶段到最后一个阶段 */}
      {nodes.length > 1 && (
        <div style={{
          position: 'absolute',
          top: '38px',
          left: `calc(${100 / nodes.length / 2}% + 10px)`,
          right: `calc(${100 / nodes.length / 2}% + 10px)`,
          height: '3px',
          background: 'linear-gradient(90deg, #1677ff 0%, #69c0ff 50%, #1677ff 100%)',
          borderRadius: '2px',
          zIndex: 1,
          boxShadow: '0 2px 4px rgba(22, 119, 255, 0.2)'
        }} />
      )}
      
      {/* 阶段 */}
      {nodes.map((node, index) => (
        <div
          key={node.id || index}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            position: 'relative',
            zIndex: 2
          }}
        >
          {/* 阶段圆点 */}
          <Tooltip 
            title={`${node.nodeName}${node.description ? ` - ${node.description}` : ''}`}
            placement="top"
          >
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1677ff 0%, #69c0ff 100%)',
              border: '4px solid #ffffff',
              boxShadow: '0 4px 12px rgba(22, 119, 255, 0.3), 0 0 0 2px #e6f7ff',
              cursor: 'pointer',
              marginBottom: '8px',
              transition: 'all 0.3s ease',
              position: 'relative',
              outline: 'none'
            }}
            onClick={() => handleNodeClick(node, index)}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.2)';
              e.target.style.boxShadow = '0 6px 16px rgba(22, 119, 255, 0.4), 0 0 0 3px #e6f7ff';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 12px rgba(22, 119, 255, 0.3), 0 0 0 2px #e6f7ff';
            }}
            >
              {/* 阶段序号 */}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#ffffff',
                fontSize: '10px',
                fontWeight: '600'
              }}>
                {index + 1}
              </div>
            </div>
          </Tooltip>
          
          {/* 阶段标签 */}
          <Tooltip title={node.nodeName} placement="bottom">
            <div style={{
              fontSize: '15px',
              color: '#1f2937',
              textAlign: 'center',
              maxWidth: '80px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              lineHeight: '1.4',
              fontWeight: '500',
              background: '#ffffff',
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid #e6f7ff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
              {node.nodeName}
            </div>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};

export default JourneyNodeTimeline;